import useMedia from '../../../../hooks/useMedia';
import Button from '../../../core/Button';

const AboutShowMore = ({text = "Подробнее",...props}) => <Button buttonType='line' isFull {...props}>{text}</Button>

export default AboutShowMore;
